import React from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'

import { formatNumber } from 'libraries/utils'

const OutBoundFeeTable = props => {
	const { t } = useTranslation();
	const { data, coupons } = props
	// processFee, unitProcessFee   入窖處理費
	// serviceFee, unitServiceFee  服務費
	// storageFee, unitStorageFee   當月儲存費
	// 入窖: 入窖處理費 當月儲存費
	// 出窖: 服務費
	const inboundFeeList = [['processFee', 'unitProcessFee'], ['storageFee', 'unitStorageFee']]
	const outboundFeeList = [['serviceFee', 'unitServiceFee']]
	const feeList = data.get('serviceAction') === "inbound" ? inboundFeeList : outboundFeeList;

	const total = feeList.reduce((acc, curr) => {
		const fee = data.get(curr[0])
		return acc.add(fee)
	}, numeral(0)).add(data.get('shippingFee'))

	const getFeeName = (name) => {
		if(name === 'processFee'){
			return '入窖處理費'
		}
		if(name === 'storageFee'){
			return '當月儲存費'
		}
		switch (data.get('shippingUrgency')) {
			case 2:
				return `服務費(${t('today_urgent')}`;  
			case 1:
				return `服務費(${t('next_day_urgent')}`; 
			default:
				return '服務費';
		}
	}

	return (
		<Table>
			<TableHead>
				<TableRow>
					<TableCell style={{paddingLeft: '30px'}}>{t('fee_item')}</TableCell>
					<TableCell>{t('fee')}</TableCell>
					<TableCell>{t('amount')}</TableCell>
					<TableCell>{t('price')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{feeList.map((item, idx) => (
					<TableRow key={idx} style={{borderBottom: '1px solid rgba(74, 79, 85, 0.1)'}}>
						<TableCell style={{paddingLeft: '30px'}}>
							{getFeeName(item[0])}
						</TableCell>
						<TableCell>
							${formatNumber(data.get(item[1]))}{t('fee_unit_price')}
						</TableCell>
						<TableCell>
							{data.get('totalBottle')}
						</TableCell>
						<TableCell>
							${formatNumber(data.get(item[0]))}
						</TableCell>
					</TableRow>
				))}
				{/* 運費 */}
				<TableRow className="total-block">
					<TableCell colSpan={2} />
					<TableCell colSpan={1} align="right" className="title">{t('shipping_fee')}</TableCell>
					<TableCell colSpan={1}>${formatNumber(data.get('shippingFee'))}</TableCell>
				</TableRow>

				{/* 小計 */}
				<TableRow className="total-block">
					<TableCell colSpan={2} />
					<TableCell colSpan={1} align="right" className="title">{t('total')}</TableCell>
					<TableCell colSpan={1}>${formatNumber(total)}</TableCell>
				</TableRow>

				{/* 扣抵 */}
				<TableRow className="total-block">
					<TableCell colSpan={2}>
						{!!data.get('coupon') &&
							`${data.getIn(['coupon', 'name'])} - ${data.getIn(['coupon', 'description'])}`
						}
					</TableCell>
					<TableCell colSpan={1} align="right" className="title">{t('coupon_fee')}</TableCell>
					<TableCell colSpan={1} >
						<Typography color={!!data.getIn(['coupon', 'couponAmount']) ? 'error' : 'initial'}>
							{!!data.getIn(['coupon', 'couponAmount']) ?
								`-${formatNumber(data.getIn(['coupon', 'couponAmount']))}`
								:
								'-'
							}
						</Typography>
					</TableCell>
				</TableRow>

				{/* 總計 */}
				<TableRow className="total-block">
					<TableCell colSpan={2} />
					<TableCell colSpan={1} align="right" className="title">{t('total_amount')}</TableCell>
					<TableCell colSpan={1}>${formatNumber(data.get('amount'))}</TableCell>
				</TableRow>

			</TableBody>
		</Table>
	)
}

export default OutBoundFeeTable
